<template>
  <v-card class="rounded-card card-shadow fill-height" color="secondary">
    <v-card-text class="text--primary pa-5">
      <v-row no-gutters>
        <v-col cols="12" class="d-flex">
          <v-icon size="100" color="white">mdi-cart-outline</v-icon>
          <div class="d-flex flex-column justify-center white--text">
              <span class="headline font-weight-bold ml-3">
              {{ total }} vendas pendentes
            </span>
            <div class="ml-3">
              Aprove ou recuse as compras pendentes e não deixe seus clientes esperando.
            </div>
          </div>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    vendas: Object,
  },
  computed: {
    total() {
      if (!this.vendas || !this.vendas.total) {
        return 0;
      }
      return this.vendas.total;
    },
  },
};
</script>
